import { date2usDotDateTime, date2usSlashDateTime } from 'helpers';
import styles from './CheckInDetails.module.scss';
import { CheckInItem } from 'types';
import { ReactComponent as ExpandIcon } from "assets/expand.svg";
import SelectComponent from 'components/Input/Select';
import { checkInTypeOptions } from '../../variables';
import React from 'react';


interface CheckInDetailsProps {
  checkIn: CheckInItem;
  returnToCheckInList: () => void;
}


const CheckInDetails = ({ checkIn, returnToCheckInList }: CheckInDetailsProps) => {
  const [selectedCheckInType, setSelectedCheckInType] = React.useState<any>(
    {value: checkIn.type, label: checkInTypeOptions.find(opt => opt.value === checkIn.type)?.label}
  );
  
  return <div className={styles.wrapper}>
    <div className={styles.headerWrapper} >      
      <div className={styles.iconWrapper} onClick={returnToCheckInList}><ExpandIcon style={{rotate: '180deg'}} /></div>      
      {/*<p className={styles.header}>{date2usSlashDateTime(checkIn.created_at)}</p>*/}
      <p className={styles.header}>
          {date2usSlashDateTime(
              checkIn.created_at,
              checkIn.is_archived
                ? 'GMT'
                : checkIn.is_archived_bg
                ? 'America/New_York'
                : undefined
            )}
        </p>
    </div>    
    <div className={styles.fmcWrapper}>
      <div className={styles.fmcName}>{checkIn.user_name}</div>
      {/* 
      <SelectComponent 
        options={checkInTypeOptions} 
        placeholder='Select a Type' 
        value={selectedCheckInType} 
        onChange={(e: any) => setSelectedCheckInType(e)}                
      />      
      */}
      <div className={styles.readOnlySelect}>
        {selectedCheckInType?.label || "—"}
      </div>
    </div>  
    {/* Blue badge pill warning message */}
    {(checkIn.is_archived) && (
      <div className={styles.badgerImportPill}>
        IMPORTED FROM BADGER & NETSUITE
      </div>
    )}  
    {(checkIn.is_archived_bg) && (
      <div className={styles.badgerImportPill}>
        IMPORTED FROM BADGER
      </div>
    )}  
    <div className={styles.notesHeaderRow}>      
      <p className={styles.notesLabel}>Meeting Notes</p>  
      <div>
        {checkIn.verified ? (
          <div className={styles.verifiedWrapper}>
            <p className={styles.verifiedText}>Verified Check-In</p>
          </div>
        ) : (
          <div className={styles.unverifiedWrapper}>
            <p className={styles.unverifiedText}>Unverified Check-In</p>
          </div>
        )}
      </div>
    </div>
    <div className={styles.notesBody}>
      {checkIn.notes}
    </div>
  </div>;
};

export default CheckInDetails;
